export const professionalData = [
  {
    slug: 'nykaa',
    companyAndRole: 'Nykaa Pvt. Ltd. — Executive, Merchandising Planning, Marketing & Product Development',
    timeline: '2022 · Mumbai',
    logo: 'nykaa.png',
    description:
      'Nykaa is one of India’s leading beauty and lifestyle e-commerce platforms, known for merging product, content, and consumer experience into one ecosystem. Working directly under the Business Head, I managed end-to-end operations across merchandising, marketing, and product development. My role demanded structure in a fast-paced environment streamlining coordination between vendors, IT, marketing, and warehouse teams to ensure accuracy, consistency, and on-time launches. I also oversaw photoshoot planning and product readiness for 100+ SKUs, aligning creative direction with operational precision to strengthen both brand storytelling and business performance.',
    highlights: [
      'Achieved 100% on-time product launches through structured workflow and inter-departmental alignment.',
      'Improved click-through rates by 15% and sell-through by 12% through optimized campaign execution and product presentation.',
      'Enhanced vendor relationships and onboarding efficiency, resulting in consistent communication and faster turnaround.',
      'Consolidated product data and inventory tracking systems, increasing transparency and reducing manual errors.',
      'Recognized for a proactive approach, strong organisational skills, and cross-functional leadership in a high-volume environment.',
    ],
    skillsGained: [
      'Vendor & Stakeholder Management',
      'Assortment & Product Planning',
      'Launch Coordination & Process Management',
      'Cross-Functional Team Collaboration',
      'Market Trend Forecasting',
      'Data Interpretation & Reporting',
      'Creative Campaign Support',
    ],
    softSkills: [
      'Organisation & Time Management',
      'Problem-Solving',
      'Communication & Negotiation',
      'Attention to Detail',
      'Team Coordination',
      'Creative Thinking',
    ],
    tools: [
      'Microsoft Excel (assortment tracking, performance analysis)',
      'Canva (creative briefs, layout planning)',
      'CRM Tools (vendor communication and product updates)',
      'WGSN (trend analysis and forecasting)',
      'Google Workspace (Sheets, Slides, Drive, Docs)',
    ],
    accent: '#ff6ba9',
    accentSecondary: '#caa7ff',
  },
  {
    slug: 'reliance-retail',
    companyAndRole: 'Reliance Retail Ltd.\nProject Intern - Merchandising & Pricing Strategy',
    timeline: '2022 · Mumbai',
    logo: 'reliance retail.png',
    description:
      'Part of Reliance Industries, one of India’s largest conglomerates led by Mukesh Ambani, Reliance Retail is the country’s leading multi-format retail giant across fashion, lifestyle, and consumer goods. Within its fashion division, I worked on pricing strategy, consumer insights, and assortment planning for 40+ stores across India. Collaborated with regional store managers to analyse customer behaviour and align product strategy with regional demand and price sensitivity.',
    highlights: [
      'Conducted nationwide analysis revealing strong regional differences in colour and style preferences.',
      'Proposed data-backed pricing adjustments that led to a 12% category-level realignment in key SKUs.',
      'Initiated direct store feedback sessions resulting in 10% faster inventory turnover through assortment optimisation.',
      'Created competitor benchmarking dashboards supporting Open-to-Buy (OTB) and markdown decisions.',
      'Recognised for analytical precision, initiative, and strong communication across merchandising teams.',
    ],
    skillsGained: [
      'Retail Merchandising & Pricing Strategy',
      'Data Analysis & Consumer Insights',
      'Regional Market Segmentation',
      'Assortment Planning',
      'Strategic Reporting',
    ],
    softSkills: [
      'Analytical Thinking',
      'Problem-Solving',
      'Adaptability',
      'Attention to Detail',
    ],
    tools: [
      'Microsoft Excel (data modelling, pricing simulation)',
      'PowerPoint (reporting and presentation)',
      'Google Workspace (Sheets, Docs, Slides)',
      'Canva (visual reporting design)',
    ],
    accent: '#9a8cff',
    accentSecondary: '#e2d8ff',
  },
  {
    slug: 'richa-group',
    companyAndRole: 'Richa Group\nIntern — Sample Coordination',
    timeline: '2021 · Delhi',
    logo: 'richa group.png',
    description:
      'Richa Group is a major export house servicing global apparel brands such as Ralph Lauren, Gap, and Calvin Klein. In my role, I supervised the sample lifecycle from cutting and sewing to dyeing and finishing, while assisting the Head of Department in operational oversight. I also introduced a color-coding and file organization system that cut workflow time by an hour daily, improving consistency across teams.',
    highlights: [
      'Managed sample readiness across all production stages, ensuring alignment with export quality standards.',
      'Assisted leadership in process coordination and quality inspections.',
      'Organised a color-coding and filing initiative that reduced duplication and accelerated sample access by over 10%.',
    ],
    skillsGained: [
      'Sample Process Management',
      'Quality Control & Inspection',
      'Workflow Optimization',
      'Production Oversight',
      'Process Documentation',
    ],
    tools: [
      'Microsoft Excel (tracking sample status, reporting)',
      'Internal Production Management Tools',
      'Communication Platforms for coordination',
    ],
    accent: '#ff9c5c',
    accentSecondary: '#ffd1b1',
  },
  {
    slug: 'siyarams',
    companyAndRole: 'Siyaram’s Silk Mills Ltd.\nIntern — Textile Production & Research',
    timeline: '2020 · Amravati',
    logo: 'siyaram\'s.png',
    description:
      'Siyaram’s is one of India’s leading textile manufacturers, known for innovation in fabrics and sustainable production systems. During my internship, I explored the textile value chain; from R&D to large-scale production and observed processes such as dyeing, knitting, and chemical treatment. Despite COVID restrictions, I visited the factories to understand machine operations and environmental practices firsthand.\nCuriosity led me to question the plant’s pollution levels and learn about their system that reduces emissions by nearly 65%. I also witnessed their work on indigo innovation in knit denims, which deepened my interest in fabric technology and responsible production.',
    skillsGained: [
      'Fabric Production Process Understanding',
      'Research & Development Exposure',
      'Sustainability Awareness',
      'Curiosity & Critical Inquiry',
      'Observation & Reporting',
    ],
    accent: '#5fd7c8',
    accentSecondary: '#c8f4ee',
  },
];

export const getProfessionalBySlug = (slug) =>
  professionalData.find((item) => item.slug === slug);
